import { render, staticRenderFns } from "./v-confirm.vue?vue&type=template&id=6e0d1019&"
import script from "./v-confirm.vue?vue&type=script&lang=js&"
export * from "./v-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports